module.exports = __webpack_public_path__ + "static/media/export-ehr.4a004afc.svg";